import {
    getLocalStorage,
    getParameterByName,
    isValueExist,
} from '@/utils/utils';

/**
 * No workspace → invite/error → EmptyWs, otherwise → CreateWorkspace.
 * Extracted from `mixins/auth.js` so both the mixin and pure functions
 * (finishOauthLogin) can share the logic without a component instance.
 */
export function handleNoWorkspaceAccess({ router, route, accounts }) {
    const hasInviteToken = !!getParameterByName('invite_token');
    const errorCode = getParameterByName('errorCode');

    if (hasInviteToken || R.isNil(accounts) || errorCode) {
        return router.push({ name: 'EmptyWs', query: route.query });
    }

    return router.push({ name: 'CreateWorkspace' });
}

/**
 * Post-login redirect for OAuth / verify flows. Reads `accounts` from the
 * caller rather than a Vuex getter so it works outside a component.
 */
export function redirectAfterJoin({
    router,
    route,
    accounts,
    isMobileSize,
    isPlanT,
}) {
    if (!isValueExist(accounts)) {
        return handleNoWorkspaceAccess({ router, route, accounts });
    }

    const hasNoPlayDemo = getLocalStorage('hasNoPlayDemo');
    if (isMobileSize && hasNoPlayDemo) {
        return router.push({
            name: isPlanT ? 'MobileDemo' : 'MyCampaigns',
        });
    }

    router.push({ name: isPlanT ? 'Dashboard' : 'MyCampaigns' });
}
